import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../../../utils/api";

//employeeId-get
export const employeeGetById = createAsyncThunk(
  "employee-byId",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.get(`/employeeid`);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//employee-list
export const employeeList = createAsyncThunk(
  "employee-list",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.get(`/employees`, { params: bodyParams });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//employee-view
export const employeeView = createAsyncThunk(
  "//employee-view",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.get(`employeeview/${bodyParams}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//employee-create
export const employeeCreate = createAsyncThunk(
  "employee-create",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.post(`employee`, bodyParams, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//employee-update
export const employeeUpdate = createAsyncThunk(
  "employee-update",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.patch(
        `/employee/${bodyParams.id}`,
        bodyParams,
        {
          headers: {
            "Content-Type": "application/json",
            "cache-control": "no-cache",
          },
        }
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// employee-delete
export const employeeDelete = createAsyncThunk(
  "employee-delete",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.delete(`employee/${bodyParams.id}`);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

//employee-edit-generatecode
export const employeeGenCode = createAsyncThunk(
  "employee-edit-generatecode",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.post(`generateapprovalcode/${bodyParams}`);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
)

//employeeLeaveCreate
export const employeeLeaveCreate = createAsyncThunk(
  "employeeLeaveCreate",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.post(`leave`, bodyParams);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
)

//employeeLeaveedit
export const employeeLeaveEdit = createAsyncThunk(
  "employeeLeaveEdit",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.post(`leaveUpdate`, bodyParams);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
)

//employeeLeavedelete
export const employeeLeaveDelete = createAsyncThunk(
  "employeeLeaveDelete",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.delete(`leave/${bodyParams}`, bodyParams);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
)

//employeedeleteGet
export const employeeLeaveGet = createAsyncThunk(
  "employeeLeaveGet",
  async (bodyParams, thunkAPI) => {
    try {
      const response = await API.get(`leave/${bodyParams}`, bodyParams);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
)
